module.exports = __webpack_public_path__ + "img/1543761531.a133ba6c.jpg";